module.exports = __webpack_public_path__ + "static/6313-09807a75caccd34cc6772d36b35872b0.png";